var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";


    function init() {
        Search();
        PrimaryNav();

        $(".site-header-logo").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".tooltip", type: "animate__heartBeat animate__repeat-2", stagger: 0 }
            ]
        });

        $(".site-header-logo .tooltip").hover(
            function () {
                $(this).removeClass("animate__heartBeat");
            },
            function () {
            }
        );
        $(".site-header-logo .tooltip").focus(function () {
            $(this).removeClass("animate__heartBeat");
        });

        /**********************************************************************************
         MOBILE FUNCTIONALITY
        /*********************************************************************************/
        var mmButton = $(".btn-mobile-menu"),
            lvl1Menu = $(".offcanvas-mobile-menu-lvl1"),
            closeButtons = lvl1Menu.find(".btn-close"),
            mobileLevel1Buttons = $(".btn-mobile-lvl1");

        lvl1Menu.on('show.bs.offcanvas', function () {
            mmButton.addClass("opened");
        });

        lvl1Menu.on('shown.bs.offcanvas', function () {
            closeButtons.addClass("opened");
        });

        lvl1Menu.on('hidden.bs.offcanvas', function () {
            if (!lvl1Menu.hasClass("show")) {
                mmButton.removeClass("opened");
                closeButtons.removeClass("opened");

                $(".offcanvas-mobile-menu-lvl2.show .btn-close").click();
            }
        });

        mobileLevel1Buttons.click(function () {
            var lvl2Offcanvas = new bootstrap.Offcanvas(document.getElementById($(this).attr("data-bs-target")));
            lvl2Offcanvas.show();
        });

        $(".offcanvas-mobile-menu-lvl2 .btn-close").click(function () {
            $(".offcanvas-mobile-menu-lvl1.show > .container > .offcanvas-header .btn-close").click();
        });
    }

    function Search() {
        const searchOffcanvas = $("#site-header-search-offcanvas");
        const searchTextField = searchOffcanvas.find("input[type='text'].form-control");

        searchOffcanvas.on("shown.bs.offcanvas", function () {
            searchTextField.focus();
        });
    }

    function PrimaryNav() {

        var hovering = false;
        var megaMenuSpeed = 300;

        var selectorMenu = $(".site-header-primary > nav > ul");
        var selectorItem = $(".site-header-primary > nav > ul").children("li").children("a, button, span");

        var level2Menu = [];
        var level2MenuWhich = 0;
        var level2MenuItems = $(".site-header-primary > nav > ul").children("li").find(".mega-menu").find("a, button, span");

        $(".site-header-primary").find(".mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        selectorMenu.hover(
            function () {

            },
            function () {
                hovering = false;
                selectorItem.blur();
                //MmOpen($(this).children("li").children("a"), megaMenuSpeed);
            }
        );

        /**********************************************************************************
         LEVEL ONE ITEM HOVER
        /*********************************************************************************/
        selectorItem.hover(
            function () {
                if (hovering !== true) {
                    MmOpen($(this), megaMenuSpeed);
                }
                else {
                    MmOpen($(this), 1);
                }
                hovering = true;
            },
            function () { }
        );

        /**********************************************************************************
         LEVEL ONE ITEM FOCUS
        /*********************************************************************************/
        selectorItem.focus(function () {
            MmOpen($(this), 1);
            hovering = true;
        });

        /**********************************************************************************
         LEVEL ONE ITEM BLUR
        /*********************************************************************************/
        selectorItem.blur(function () {
            if (hovering === false) {
                MmClose($(this), megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorItem.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button, span").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button, span").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                level2Menu = [];
                $(this).siblings(".mega-menu").find("a:visible, button:visible").each(function () { level2Menu.push(this); });
                level2MenuWhich = 0;
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this);
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL 2 ITEMS ARROWS
        /*********************************************************************************/
        level2MenuItems.keydown(function (e) {
            /* right arrow */
            if (e.keyCode === 39) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").next("li").children("a, button, span").focus();
            }
            /* left arrow */
            else if (e.keyCode === 37) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").prev("li").children("a, button, span").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich < level2Menu.length - 1) { level2MenuWhich++; }
                else { level2MenuWhich = 0; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // up arrow
            else if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich > 0) { level2MenuWhich--; }
                else { level2MenuWhich = level2Menu.length - 1; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuButton = $(this).parents(".mega-menu").siblings("a, button, span");
                MmClose(MenuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         ENTIRE EVERYTHING KEYPRESS - should we close that menu??
        /*********************************************************************************/
        selectorMenu.keydown(function (e) {
            if (e.keyCode === 9) {
                hovering = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });
    }

    function MmOpen(Menu, Speed) {
        Menu.attr("aria-expanded", "true").siblings(".mega-menu").stop().slideDown(Speed);
        MmClose(Menu.parents("li").siblings("li").children("a, button, span"), Speed);
        Menu.parents("li").addClass("open").removeClass("no-hover").siblings("li").addClass("no-hover");
    }

    function MmClose(Menu, Speed) {
        Menu.attr("aria-expanded", "false").siblings(".mega-menu").stop().slideUp(Speed);
        Menu.parents("li").removeClass("no-hover").removeClass("open").siblings("li").removeClass("no-hover").removeClass("open");
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});